const mapMetaTranslations = (metaTranslations, translationKey) =>
  metaTranslations[translationKey] || translationKey;

export default mapMetaTranslations;
